"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let CarouselsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.datas = new Array();
    this.total = 0;
  }
};
CarouselsModel.model = "data.set";
CarouselsModel = __decorateClass([
  Annotation.ModelMeta
], CarouselsModel);
export let CarouselModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.tip = "";
    this.title = "";
    this.btnStr = "";
    this.btnUrl = "";
    this.bgImg = "";
    this.bgUrl = "";
  }
};
CarouselModel.model = "carousel";
CarouselModel = __decorateClass([
  Annotation.ModelMeta
], CarouselModel);
